import React from "react";

export const InitCreditContext = React.createContext();